// extracted by mini-css-extract-plugin
module.exports = {"avatarUploader":"SamplesField-styles_avatarUploader__fNdjj","ant-upload":"SamplesField-styles_ant-upload__NuR12","sampleUploadField":"SamplesField-styles_sampleUploadField__qBaz3"};